// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "f98547581f72";
export const BUILD_VERSION_NUMBER = 27;
